import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

const hotCardImages = [
  'https://readdy.ai/api/search-image?query=Editorial%20style%20photograph%20of%20a%20dramatic%20stage%20spotlight%20on%20dark%20background%2C%20warm%20golden%20lighting%2C%20entertainment%20industry%20atmosphere%2C%20mysterious%20vibe%2C%20simple%20composition%20with%20negative%20space%2C%20soft%20shadows%2C%20clean%20minimal%20background&width=600&height=600&seq=hot-topic-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Modern%20livestreaming%20studio%20setup%20with%20ring%20light%20and%20microphone%2C%20simple%20neutral%20background%2C%20warm%20ambient%20lighting%2C%20editorial%20product%20photography%20style%2C%20clean%20minimal%20composition%2C%20soft%20depth%20of%20field&width=600&height=600&seq=hot-topic-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Romantic%20evening%20cityscape%20with%20soft%20bokeh%20lights%2C%20warm%20pink%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20simple%20elegant%20composition%2C%20clean%20background&width=600&height=600&seq=hot-topic-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Abstract%20industrial%20texture%20with%20warm%20metallic%20tones%2C%20soft%20diffused%20lighting%2C%20minimal%20modern%20composition%2C%20clean%20background%2C%20subtle%20patterns%2C%20editorial%20style%2C%20warm%20amber%20and%20coral%20color%20palette&width=600&height=600&seq=hot-topic-04&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20warm%20professional%20lighting%2C%20minimal%20modern%20design%2C%20clean%20neutral%20background%2C%20empty%20stage%20with%20dramatic%20lighting%2C%20editorial%20photography%2C%20soft%20atmosphere%2C%20entertainment%20industry%20aesthetic&width=600&height=600&seq=hot-topic-05&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Elegant%20fashion%20brand%20storefront%20at%20night%20with%20warm%20golden%20lighting%2C%20luxury%20minimal%20design%2C%20clean%20glass%20windows%2C%20editorial%20photography%20style%2C%20simple%20composition%2C%20soft%20shadows%2C%20sophisticated%20atmosphere&width=600&height=600&seq=hot-topic-06&orientation=squarish',
];

export default function HotTopicsSection() {
  const hotArticles = getHotArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
              Trending Now
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              实时<span className="text-primary-500">热搜</span>
            </h2>
          </div>
          <Link
            to="/category/chigua-qianxian"
            className="hidden md:inline-flex px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide snap-x snap-mandatory">
          {hotArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-[260px] md:w-[280px] snap-start group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden bg-background-50 hover:bg-background-50 transition-colors">
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={hotCardImages[index]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`今日看料 - ${article.title}`}
                  />
                  <div className="absolute top-3 left-3 w-8 h-8 rounded-lg bg-foreground-950/80 backdrop-blur-sm flex items-center justify-center">
                    <span className="text-background-50 text-xs font-bold">{index + 1}</span>
                  </div>
                  {article.isTop && (
                    <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                      置顶
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2 py-0.5 rounded">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-500">{article.publishDate}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-xs text-foreground-500 flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount > 10000
                        ? `${(article.viewCount / 10000).toFixed(1)}万`
                        : article.viewCount}
                    </span>
                    <span className="text-lg font-bold text-accent-500">
                      {article.heatIndex > 1000000
                        ? `${(article.heatIndex / 1000000).toFixed(1)}M`
                        : `${(article.heatIndex / 10000).toFixed(1)}万`}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}

          <Link
            to="/category/chigua-qianxian"
            className="flex-shrink-0 w-[260px] md:w-[280px] snap-start flex items-center justify-center"
          >
            <div className="text-center">
              <div className="w-14 h-14 rounded-full bg-foreground-950 flex items-center justify-center mx-auto mb-3 group hover:bg-foreground-800 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-background-50 text-xl"></i>
              </div>
              <p className="text-sm text-foreground-600 font-medium">查看更多热搜</p>
            </div>
          </Link>
        </div>

        <div className="mt-4 flex justify-center md:hidden">
          <Link
            to="/category/chigua-qianxian"
            className="px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部热搜 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}